import axios from 'axios';

const instance = axios.create({
  baseURL: localStorage.getItem('baseUrl') || 'https://admin.hyprism.com/api',
});

export default instance;
